import { useMemo, useState } from 'react';
import { ExperimentColumnData, VariantRowItems } from 'modules/experiments/types';
import { DESCENDING } from 'constants/sortDirections';
import { StyledVariantTableHeader, StyledVariantTableRows, StyledVariantTable } from './Styles';

type VariantTableProps = {
  columns: ExperimentColumnData[];
  rows: VariantRowItems;
  id?: string;
};

export const VariantTable = ({ columns, rows, id }: VariantTableProps) => {
  const [sortedBy, setSortedBy] = useState('variantName');
  const [sortDirection, setSortDirection] = useState<string>(DESCENDING);
  const colDataWithName = useMemo(() => columns.map((col) => ({ ...col, name: '' })), [columns]);

  return (
    <StyledVariantTable id={id}>
      <StyledVariantTableHeader
        columns={colDataWithName}
        sortedBy={sortedBy}
        setSortedBy={setSortedBy}
        sortDirection={sortDirection}
        setSortDirection={setSortDirection}
      />
      <StyledVariantTableRows idKey="variantTemplateID" rows={rows} columns={colDataWithName} />
    </StyledVariantTable>
  );
};
